export const normalizeDateTime = (value) => {
  if (!value) return '';
  if (value instanceof Date) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(value.getHours())}:${pad(value.getMinutes())}`;
  }
  return String(value)
    .replace('T', ' ')
    .replace('Z', '')
    .split('.')[0]
    .slice(0, 16);
};

export const formatTime = (value) => (value ? String(value).slice(0, 5) : '');
